import React from 'react';
import { mobileMediaQuery } from '../../Theming';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Hero from './Hero';
import TreesFunded from './TreesFunded';
import EquivalentSection from './EquivalentSection';
import HowItWorks from './HowItWorks';
import Footer from './Footer';
import { useTreePlantedContext } from '../TreeplantingContext';

const Container = styled.main`
  padding-inline: 50px;
  padding-block: 64px;
  margin: auto;
  max-width: 1400px;

  ${mobileMediaQuery} {
    padding-inline: 15px;
    padding-block: 24px;
  }
`;

const TreePlanting: React.FC = () => {
  const { t } = useTranslation();
  const { treesPlanted, todaysTreePlantingTick, tonnesOfCo2, milesDriven } =
    useTreePlantedContext();

  return (
    <Container>
      <Hero
        headerText={t('treePlantingV2.hero.heading')}
        subText={t('treePlantingV2.hero.subHeading')}
      />
      <TreesFunded
        totalNumOfTrees={treesPlanted}
        numOfTreesToday={todaysTreePlantingTick}
      />
      <EquivalentSection tonnesOfCo2={tonnesOfCo2} milesDriven={milesDriven} />
      <HowItWorks />
      <Footer />
    </Container>
  );
};

export default TreePlanting;
